import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UITruncateString from 'UIComponents/text/UITruncateString';

/**
 * Component used for the displaying the selected value in a UISelect whose
 * options use a network icon. Intended to be set as a UISelect's `valueComponent`
 * prop.
 */
const NetworkSelectValue = (_ref) => {
  let {
    option: {
      networkIcon,
      text
    }
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["option"]);

  return /*#__PURE__*/_jsx("div", Object.assign({}, props, {
    children: /*#__PURE__*/_jsxs(UIMedia, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UIMediaLeft, {
        children: networkIcon
      }), /*#__PURE__*/_jsx(UIMediaBody, {
        className: "m-left-2",
        children: /*#__PURE__*/_jsx(UITruncateString, {
          placement: "right",
          tooltip: text,
          children: text
        })
      })]
    })
  }));
};

export default NetworkSelectValue;